import { Box, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import { loadContact } from '@sophocles/features/warehouse/orders/api';
import { contactSlice } from '@sophocles/features/warehouse/orders/slice';
import ContactForm from '@sophocles/views/sales/forms/ContactForm';

function ContactFormView() {
  const { customerId, siteGroupId, contactId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const contact = useSelector(state => contactSlice.selectors.selectEntityById(state, contactId));

  useEffect(() => {
    if (contactId != null && contact == null) {
      setLoading(true);
      dispatch(loadContact(contactId)).finally(() => {
        setLoading(false);
      });
    }
  }, []);

  const isEditing = !!contact;

  return (
    <AppNav loading={loading} page={`customer_settings_contacts`} notFullHeight={true}>
      <Box sx={{ top: '64px', mx: 2, pb: '24px', display: 'flex', flexDirection: 'column', flex: 1 }}>
        <TitleBar showBackButton title={'Contact'} />
        <Paper sx={{ display: 'flex', flex: 1, mx: 1 }}>
          {((contactId && contact) || !contactId) && (
            <ContactForm
              contact={contact}
              customerId={customerId}
              siteGroupId={siteGroupId}
              onClose={() => {
                if (customerId != null && siteGroupId != null) {
                  navigate(`/c/${customerId}/plant/${siteGroupId}/settings`);
                } else {
                  navigate(`/c/${customerId}/settings?tab=2`);
                }
              }}
            />
          )}
        </Paper>
      </Box>
    </AppNav>
  );
}

export default ContactFormView;
